import DualList from './DualList';

export default DualList;
